export const inlineLabelEditorFormNamePrefix = 'inline-label-editor-form-';

const generateInlineLabelEditorFormName = uuid =>
  inlineLabelEditorFormNamePrefix + uuid;

export default generateInlineLabelEditorFormName;
